import React from 'react';
import legendPdf from '../assets/legend.pdf';

function Legend() {
  return (
    <div className="legend">
      <h1>Legend</h1>
      <object
        data={legendPdf}
        type="application/pdf"
        width="100%"
        height="800px"
      >
        <p>Your browser does not support PDFs. 
           <a href={legendPdf}>Download the PDF</a>.</p>
      </object>
    </div>
  );
}

export default Legend;